export default function PolicyCostData() {
    return {
        text: {
                title: "How much will your policy cost?",
                largeText: true,
                paragraphs: [
                  "There are several factors that determine your price for coverage. In addition to amount and term, the insurance companies will review your age, gender, health as well as financial and lifestyle background to evaluate your risk classification which drives your final price.",
              ],
            },
        callToActionText: "SEE YOUR QUOTE",
        image: "/product-landing/term/policy-cost.jpg",
    };
}
